import styled from 'styled-components';

const EnquireFormStyles = styled.section`
  .left {
    position: relative;
    text-align: center;
  }

  .quote {
    display: flex;
    flex-wrap: wrap;
    position: absolute;
    bottom: 3rem;
    left: 10%;
    z-index: 10;
    width: 80%;
    font-size: 1.3rem;
    font-style: italic;
    line-height: 1.6;
    color: var(--color-sand);
    text-align: left;

    .icon {
      width: 2.1rem;
      height: 2.1rem;
      margin-bottom: 0.5rem;
    }

    .byline {
      width: 100%;
      margin-top: 1rem;
      font-size: 1.2rem;
    }
  }

  .box {
    max-width: 34rem;
    margin: -2rem auto 3rem auto;
    padding: 1.5rem;
    border: solid 0.063rem var(--color-bark);
    text-align: center;
  }

  .image-wrapper,
  .image {
    max-width: 30rem;
    max-height: 36rem;
  }

  .image-wrapper {
    position: relative;
    margin: 0 auto 3rem;
  }

  .image {
    width: 100%;
    object-fit: cover;
    object-position: center;

    &::before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      pointer-events: none;
      background-color: var(--color-bark);
      opacity: 0.4;
    }
  }

  .heading {
    font-weight: 400;
    font-size: 1.1rem;
    margin: 0 0 1rem;
    text-align: center;
  }

  .intro {
    display: block;
    background-color: var(--color-swiss-coffee);
    padding: 1.5rem;
    margin-bottom: 1rem;
  }

  .form {
    padding: 1rem 0 0;

    .form-body {
      display: grid;
      column-gap: 1rem;
      row-gap: 1.5rem;
    }

    .form-footer {
      display: flex;
      justify-content: flex-end;
      flex-wrap: wrap;
      width: 100%;
      margin: 4rem 0 0;

      .success-wrapper {
        width: 100%;
        opacity: ${(props) => (props?.showEventFormSuccess ? '1' : '0')};
        transition: opacity 0.4s;

        .success {
          margin: 2rem 0 0;
          font-size: 1.2rem;
          font-weight: var(--font-weight-bold);
        }
      }
    }
  }

  @media (min-width: 768px) {
    .inner {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      max-width: 70rem;
      margin: 0 auto;
      gap: 2rem;

      .top {
        width: 100%;
      }

      .left {
        width: calc(40% - 1rem);
      }

      .right {
        width: calc(60% - 1rem);
      }
    }

    .quote {
      left: 8%;
      bottom: 2rem;
      width: 84%;
      font-size: 1.2rem;

      .byline {
        font-size: 1rem;
      }
    }

    .image-wrapper {
      position: sticky;
      top: 6rem;
      left: 0;
      margin: 3rem auto 2rem;
    }

    .heading {
      font-size: 1.25rem;
      margin: 0 0 1.5rem;
    }

    .form {
      width: 100%;
      margin: 0 auto;
    }
  }

  @media (min-width: 992px) {
    .inner {
      gap: 5rem;

      .top {
        width: 100%;
      }

      .left {
        width: 35%;
      }

      .right {
        width: ${(props) => (props?.image ? '55%' : '60%')};
      }
    }

    .image-wrapper,
    .image {
      max-height: 36rem;
    }

    .image-wrapper {
      margin: 3.5rem auto 2rem;
    }

    .quote {
      font-size: 1.4rem;
      line-height: 1.4;

      .icon {
        width: 2.5rem;
        height: 2.5rem;
        margin-bottom: 0.5rem;
      }

      .byline {
        font-size: 1.2rem;
      }
    }

    .form {
      .form-body {
        grid-template-columns: 1fr 1fr;
        align-items: flex-start;
        column-gap: 2rem;
        row-gap: 2rem;

        & > div:nth-child(5) {
          grid-column: 1 / span 2;
        }

        ${(props) =>
          !props?.event &&
          `
        & > div:nth-last-child(2) {
          grid-column: 1 / span 2;
        }`}

        & > div:last-child {
          grid-column: 1 / span 2;
        }

        ${(props) =>
          !props?.partnership &&
          !props?.event &&
          `
            & > div:nth-last-child(3) {
              grid-column: 1 / span 2;
            }
        `}
      }
    }
  }

  @media (min-width: 1200px) {
    .quote {
      left: 10%;
      width: 80%;
      font-size: 1.6rem;
    }
  }
`;

export default EnquireFormStyles;
